import type { State } from '../../typings'

export function selectAllFiltersReducer(state: State): State {
  const newState: State = { ...state }

  newState.filters.closingActivities.filters.forEach((x) => {
    x.isSelected = true
  })

  newState.filters.customActivities.filters.forEach((x) => {
    x.isSelected = true
  })

  newState.filters.statusUpdates.filters.forEach((x) => {
    x.isSelected = true
  })

  return newState
}
